import { makeStyles } from '@rbx/ui';

const usePageBreadcrumbs = makeStyles()((theme) => ({
  link: {
    fontWeight: theme.typography.fontWeightRegular,
  },
  iaLink: {
    '&:hover': {
      textDecorationColor: theme.palette.content.muted,
    },
  },
}));

export default usePageBreadcrumbs;
